import iso from '../../assets/files/iso/iso.pdf';

const isoData = {
    text : "Desde el año 2006, GPRO Valparaíso Palace Hotel & Spa obtiene anualmente el certificado ISO 14001 por su gestión de la calidad medioambiental. Así mismo, hemos recibido las distinciones de “Eco-Resort” y “Unwelt Champion (Campeón medioarnbiental)” otorgadas por el Touroperador TUI.",
    file : iso
}

export default isoData;